import React from 'react';
import { RadioButton as PrimeRadioButton } from 'primereact/radiobutton';
import { _Object } from 'utils/interfaces';
import { Message } from 'primereact/message';

const RadioButton = ({ name, value, onChange, options, required, className = '', label, error }: _Object) => {
  return (
    <div className={`form-group mb-3 ${className}`}>
      {label && <label className="label-form mb-1 d-block">{label} {required && <span className="required-field">*</span>}</label>}

      {
        options && options?.map((option: { [key: string]: string }, i: number) => {
          return (
            <div className="form-check form-check-inline" key={i}>
              <PrimeRadioButton
                inputId={`${name}-${i}-${option.value}`}
                name={name}
                value={option.value}
                onChange={onChange}
                checked={value == option.value}
                className="form-check-input"
              />
              <label htmlFor={`${name}-${i}-${option.value}`} className="form-check-label">{option.label}</label>
            </div>
          )
        })
      }
      {error && (
        <Message severity="error" text={error} />
      )}
    </div>
  );
}

export default RadioButton;
